import React, {useEffect, useRef} from "react"
import styled  from "styled-components"
import {Container, Tokens, FadeIn, useWindowSize} from "./DesignSystem"
import ProjectItem from './ProjectItem'

const Wrapper = styled.section`
    position: relative;
    background: var(--gray);
    padding: 2rem 0 10rem 0;
    border-radius: 0 0 4rem 4rem;
`
const ProjectListWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    @media ${Tokens.lg} {
        margin: 0;
    }
`;

const SectionHeading = styled.h2`
    text-align: left;
    font-size: var(--fontSizeXL);
    transition: all 0.2s;
    margin-bottom: 2rem;
    width: 100%;
`

const ProjectList = React.memo(props => {

    const projects = props.data.allMdx.edges;
    // const delay = useMemo(() => (props.introInView ? 1.3 : 0), [props.introInView]);
    const ref = useRef(null);
    const windowSize = useWindowSize();
   
    // set the equal height for item
    useEffect(() => {
        if (ref.current.children) {
            let maxHeight = Array.from(ref.current.children).reduce((acc, e) => {
                e.querySelector('main').style.height = null;
                let h = e.querySelector('main').offsetHeight;
                return (h > acc) ? h : acc;
            }, 0);
            if (windowSize.width > 768) {
                Array.from(ref.current.children).forEach(e => {
                    e.querySelector('main').style.height = maxHeight+'px';
                });
            }   
        }
    });

    const Content = () => {
        return (
        <React.Fragment>
            <SectionHeading>Selected Projects</SectionHeading>
            <ProjectListWrapper ref={ref}>
            {projects.map(({ node }, i) => {
                const fields = {
                    slug: node.fields.slug
                }
                const data = {...node.frontmatter, ...fields}
                return (
                <ProjectItem total={projects.length} i={i} key={data.title} {...data} />
                )
            })}
            </ProjectListWrapper>
        </React.Fragment>
        );
    };

    return (
        <Wrapper>
        <Container>
        <FadeIn delay={(props.location.fromPost) ? 0 : 1.1} duration={0.6}><Content /></FadeIn>
        </Container>
        </Wrapper>
    )
});
export default ProjectList;